import React from "react";

function FlatButton({name, icon, onClick}) {
    return (
        <button
            className={"rounded-lg px-6 h-10 text-white font-bold bg-primary flex flex-row items-center justify-between"} onClick={onClick}>
            {   icon &&
                <div className={"mr-4"}>
                    {icon}
                </div>
            }
            {name}
        </button>
    );
}

export default FlatButton;